import React from "react";
import PropTypes from "prop-types";
import './MailchimpEmbedded.css';

class MailchimpEmbedded extends React.Component {

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      email: ''
    }
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange(evt) {
    this.setState({email: evt.target.value});
  }

  handleSubmit(evt) {
    this.formRef.submit();
    console.log(evt);
  }

  render() {

    const hiddenInputStyle = {
      position: 'absolute',
      left: '-5000px'
    };

    return (

        <React.Fragment>
        <div id="mc_embed_signup">
        <form action="https://albumist.us18.list-manage.com/subscribe/post?u=6733e6d0f10922e8f127e1851&amp;id=f6d6025d49" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" novalidate ref={this.formRef} >
        <div id="mc_embed_signup_scroll" onSubmit={this.handleSubmit} >
        <input type="email" value={this.state.email} onChange={this.onChange} name="EMAIL" className="email" id="mce-EMAIL" placeholder="email address" required />
        <div style={hiddenInputStyle} aria-hidden="true">
        <input type="text" name="b_6733e6d0f10922e8f127e1851_f6d6025d49" tabindex="-1" value="" />
        </div>
        <div className="clear">
        <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" />
        </div>
        </div>
        </form>
        </div>
        </React.Fragment>
    );
  }    
};

export default MailchimpEmbedded;



// WEBPACK FOOTER //
// ./src/components/MailchimpEmbedded/MailchimpEmbedded.js